import React from 'react';
import { up } from 'styled-breakpoints';
import styled from 'styled-components';
import { pxToRem } from '../../../styles/utils';

const StyledHorizontalLine = styled.article`
  border-bottom: 2px solid ${(props) => props.theme.palette.grey4};
  opacity: 0.6;
`;

const StyledHorizontalLineCard = styled.article`
  /* border: 1px solid #f0f0f0; */
  border-bottom: ${pxToRem(2)} solid ${(props) => props.theme.palette.grey4};

  opacity: 0.6;
`;

export function HorizontalLine() {
  return <StyledHorizontalLine />;
}

export function HorizontalLineWithinCard() {
  return <StyledHorizontalLineCard />;
}
